import axios from 'axios';
import qs from 'qs';
import { jwtDecode } from 'jwt-decode';
import { resetStepsDataSet } from 'store/steps';
import { resetUserDataSet } from 'store/userData';
import { queryClient } from 'index';
import { store } from '../'
import { tokenDateIsValid } from 'utils';
import { handleHttpCode } from 'assets/constants';
const { webHook_Error, script_error } = handleHttpCode;

const fetchJson = (url) => fetch(url).then((x) => x.json());

export const envData = {};

export const getEnv = (async () => {
  const config = (await (await fetch('./env.json')).json()); // TODO [DA]: Add base href to the page before production
  return config;
})().then(data => Object.assign(envData, data));

const getHeaders = () => { return { 'Content-Type': 'application/json' } };

const getRecaptchaToken = (token) => { return { 'x-recaptcha-token': token } };

const instance = getEnv.then((config) =>
  axios.create({
    baseURL: config.apiBaseUrl,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    headers: getHeaders(),
  })
);

function resetApplication() {
  sessionStorage.removeItem("end_user_token");
  queryClient.removeQueries({ queryKey: ['active-query', 'customer-info'] });
  queryClient.invalidateQueries({ queryKey: ['active-query'] });

  store.dispatch(resetStepsDataSet());
  store.dispatch(resetUserDataSet());

}

function filterUnSupportedMessages(results) {
  if (!results) return [];

  const notValidResponse = results.messages.filter(message => !message || isNaN(message.messageType))
  if (notValidResponse?.length > 0)
    console.error('Not valid response from server', notValidResponse)

  const messages = results.messages
    .filter(message => message && typeof message.messageType === 'number')

  return messages;
}

instance.then((instance) => {
  instance.interceptors.request.use(
    (config) => {
      const token = `${sessionStorage.getItem('end_user_token') || ''}`

      if (!!token && token !== 'mockedToken') {
        const decoded = jwtDecode(token);

        if (!tokenDateIsValid(decoded.exp)) {
          resetApplication();
        }

      }

      config.headers.authorization = token;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  )

  instance.interceptors.response.use(
    (response) => {
      if (response.request.responseURL.includes('journeyconfiguration') && response.data?.errorCode > 0) {
        const { errorCode, errorMessage, data } = response.data || {};
        return ({ ...data, errorCode, errorMessage });
      }
      else {
        const { errorCode, data, scriptResults } = response.data || {};
        if (scriptResults?.messages?.length > 0) {
          return ({ ...data, errorCode, scriptMessages: filterUnSupportedMessages(scriptResults) });
        }

        return response.data.data;
      }
    },
    (obj) => {
      const response = obj.response
      if (!response?.status)
        return Promise.reject(response)
      switch (response.status) {
        case 401:
          resetApplication();
          throw response.data;
        case 409:
          const { errorCode, scriptResults, errorMessage: serverErrorMessage, webhookResults, ...data } = response.data || {};
          if ([webHook_Error, script_error].includes(errorCode)) {
            const errorMessage = webhookResults?.messages?.map(({ message }) => message)?.join("\n ") || serverErrorMessage;
            throw ({ ...data, errorCode, errorMessage, webhookResults, scriptMessages: filterUnSupportedMessages(scriptResults) });
          }
          throw { ...data, errorCode, errorMessage: serverErrorMessage };
        default:
          throw response.data;
      }

    }
  )
}
);

// Response interceptor for API calls
const POST = (url, body, config) => instance.then((x) => x.post(url, body, config));
const GET = (url, body) => instance.then((x) => x.get(url, body));
const PUT = (url, body) => instance.then((x) => x.put(url, body));
const DELETE = (url, body) => instance.then((x) => x.delete(url, body));

export { POST, GET, PUT, DELETE, getRecaptchaToken, fetchJson };

// export const getEnvApi = (async () => {
//   return (await (await fetch('./env.json')).json()).then(x => envRef.current = x); // TODO [DA]: Add base href to the page before production
// })();

// const envRef = { current: null };

// export function getEnv() { return envRef.current }